/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ips-checked-card[_ngcontent-%COMP%]{background-color:#dff0d8;border-color:#228b22}.ips-checked-card[_ngcontent-%COMP%]   .check[_ngcontent-%COMP%]{color:#228b22}.check[_ngcontent-%COMP%]{font-size:14pt;color:#e4e4e4}"];
export { styles as styles };
